export const getEditRightsSuccess = (name: string): string =>
  `Права на мобильное приложение "${name}" обновлены`;
export const getEditRightsError = (name: string): string =>
  `Не удалось обновить права на мобильное приложение "${name}"`;
